//import { useWebAppContext } from 'app/src/shared/hooks'
import { MealVouchersApp } from '@welfare/postepasto-app'
import { companyagreementApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { onError, onErrorMutation } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import type atlas from 'azure-maps-control'
import React, { useCallback, useEffect, useState } from 'react'

export function MealVouchersContainer() {
  const context = useWebAppContext()

  const [showMealVouchersApp, setShowMealVouchersApp] = React.useState(false)
  const [mapToken, setMapToken] = useState<string | undefined>(undefined)

  const apiConfiguration = companyagreementApi.useConfigurationGet({})

  useEffect(() => {
    context.update({ breadCrumbItems: [] })
  }, [context])

  useEffect(() => {
    setShowMealVouchersApp(!!apiConfiguration?.data)
    setMapToken(apiConfiguration?.data?.mapToken)
  }, [apiConfiguration?.data])

  const getMapToken: atlas.getAuthTokenCallback = useCallback(
    (resolve: (value?: string) => void): void => {
      apiConfiguration.refetch().then((configurationResponse) => {
        setMapToken(apiConfiguration?.data?.mapToken)
        resolve(configurationResponse.data?.mapToken)
      })
    },
    [apiConfiguration],
  )

  return (
    <PageWidget>
      {showMealVouchersApp && (
        <MealVouchersApp
          atlasMapId={apiConfiguration?.data?.mapId}
          atlasMapToken={mapToken}
          onError={onError}
          onErrorMutation={onErrorMutation}
          showToastMessage={context.showToastMessage}
          getMapToken={getMapToken}
          mode='web'
        />
      )}
    </PageWidget>
  )
}
